import { render, staticRenderFns } from "./GoogleForm.vue?vue&type=template&id=6f40d405&scoped=true"
import script from "./GoogleForm.vue?vue&type=script&lang=js"
export * from "./GoogleForm.vue?vue&type=script&lang=js"
import style0 from "./GoogleForm.vue?vue&type=style&index=0&id=6f40d405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40d405",
  null
  
)

export default component.exports